import { boolean, InferType, object, ObjectSchema, string, mixed } from "yup";
import { CriarFornecedorContract } from "../contracts/criar-fornecedor.contract";
import { SupplierTypeEnum } from "../../../shared/utils/enum/enum";

export const criarFornecedorSchema: ObjectSchema<CriarFornecedorContract> = object({
  type: mixed<SupplierTypeEnum>()
    .oneOf(Object.values(SupplierTypeEnum), "Tipo de fornecedor inválido")
    .required("Tipo de fornecedor é obrigatório"),
  cnpj: string()
    .nullable()
    .default(null)
    .when("type", {
      is: (type: SupplierTypeEnum) => type === SupplierTypeEnum.PJ || type === SupplierTypeEnum.MEI,
      then: (schema) => schema.required("CNPJ é obrigatório para fornecedores PJ ou MEI"),
      otherwise: (schema) => schema.notRequired(),
    }),
  cpf: string()
    .nullable()
    .default(null)
    .when("type", {
      is: (type: SupplierTypeEnum) => type === SupplierTypeEnum.PF,
      then: (schema) => schema.required("CPF é obrigatório para fornecedores PF"),
      otherwise: (schema) => schema.notRequired(),
    }),
  fantasyName: string()
    .nullable()
    .default(null)
    .when("type", {
      is: (type: SupplierTypeEnum) => type === SupplierTypeEnum.PJ || type === SupplierTypeEnum.MEI,
      then: (schema) => schema.required("Nome Fantasia é obrigatório para PJ ou MEI"),
      otherwise: (schema) => schema.notRequired(),
    }),
  corporateName: string()
    .nullable()
    .default(null)
    .when("type", {
      is: (type: SupplierTypeEnum) => type === SupplierTypeEnum.PJ || type === SupplierTypeEnum.MEI,
      then: (schema) => schema.required("Razão Social é obrigatória para PJ ou MEI"),
      otherwise: (schema) => schema.notRequired(),
    }),
  fullName: string()
    .nullable()
    .default(null)
    .when("type", {
      is: (type: SupplierTypeEnum) => type === SupplierTypeEnum.PF,
      then: (schema) => schema.required("Nome completo é obrigatório para PF"),
      otherwise: (schema) => schema.notRequired(),
    }),
  stateRegistration: string().nullable().default(null),
  municipalRegistration: string().nullable().default(null),
  address: object().shape({
    zipCode: string().required("CEP é obrigatório"),
    street: string().required("Rua é obrigatória"),
    number: string().required("Número é obrigatório"),
    neighborhood: string().required("Bairro é obrigatório"),
    city: string().required("Cidade é obrigatória"),
    state: string().required("Estado é obrigatório"),
    complement: string().default(""),
  }),
  phone: string().nullable().default(null),
  email: string().nullable().email("E-mail inválido").default(null),
  contact: string().nullable().default(null),
  notes: string().nullable().default(null),
  active: boolean().required("É obrigatório informar se o fornecedor está ativo ou inativo!"),
});

export type CriarFornecedorFormData = InferType<typeof criarFornecedorSchema>;